import script from "./ProgressIndicator.vue?vue&type=script&lang=ts&setup=true"
export * from "./ProgressIndicator.vue?vue&type=script&lang=ts&setup=true"

import "./ProgressIndicator.vue?vue&type=style&index=0&id=3b9bd133&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3b9bd133"]])

export default __exports__